import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { CheckInState } from './types'
import { RootState } from '../types'

export const state: CheckInState = {
  offerInformation: { offerId: null, offerRevisionId: null },
  checkedInOfferItems: [],
  offerItem: null,
  requestGetCheckedInOfferItems: false,
  requestGetOfferItem: false,
  requestPostCheckinOfferItem: false,
  selectedCondition: null,
  error: null,
}

const namespaced: boolean = true

export const checkin: Module<CheckInState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
}
